"use client";
import * as React from "react";
const SvgEventNoteRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 14 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M10.11 7.2H3.9a.8.8 0 0 0-.78.8c0 .44.35.8.78.8h6.22c.43 0 .78-.36.78-.8s-.35-.8-.78-.8Zm2.33-5.6h-.77V.8a.8.8 0 0 0-.78-.8.8.8 0 0 0-.78.8v.8H3.9V.8a.8.8 0 0 0-.78-.8.8.8 0 0 0-.78.8v.8h-.77C.69 1.6 0 2.32 0 3.2v11.2c0 .88.7 1.6 1.56 1.6h10.88c.86 0 1.56-.72 1.56-1.6V3.2c0-.88-.7-1.6-1.56-1.6m-.77 12.8H2.33a.8.8 0 0 1-.77-.8v-8h10.88v8a.8.8 0 0 1-.77.8m-3.9-4H3.9a.8.8 0 0 0-.78.8c0 .44.35.8.78.8h3.89c.43 0 .78-.36.78-.8s-.35-.8-.78-.8Z" }));
export {
  SvgEventNoteRound as default
};
